import Enum from '../utils/Enum';

export * from './api';

/**
 * 环境配置
 * 按环境和地区分类的API基础URL
 */
export const API_DOMAIN = {
  // 生产环境
  production: {
    domestic: 'https://sdk.qcplay.com',    // 生产环境-国内
    overseas: 'https://sdk-sg.qcplay.com'  // 生产环境-海外
  },
  // 开发环境
  development: {
    domestic: 'https://tsdk.qcplay.com',   // 开发环境-国内
    overseas: 'https://tsdk-sg.qcplay.com' // 开发环境-海外
  },
  // 测试环境
  test: {
    domestic: 'https://tsdk.qcplay.com',   // 测试环境-国内
    overseas: 'https://tsdk-sg.qcplay.com' // 测试环境-海外
  }
} as const;

// /**
//  * 获取API基础URL
//  * @param environment 环境类型
//  * @param region 地区类型
//  * @returns API基础URL
//  */
// export function getBaseUrl(environment: keyof typeof API_CONFIG, region: 'domestic' | 'overseas'): string {
//   return API_CONFIG[environment][region];
// }

// 环境
export const ENVIRONMENT = new Enum()
  .setItem('DEVELOPMENT', 'development', '开发环境')
  .setItem('TEST', 'test', '测试环境')
  .setItem('PRODUCTION', 'production', '生产环境');

// 地区
export const REGION = new Enum()
  .setItem('DOMESTIC', 'domestic', '国内')
  .setItem('OVERSEAS', 'overseas', '海外');

// 协议
export const AGREEMENT = new Enum()
  .setItem('SERVICE', 'https://law.qingcigame.com/zh-cn/service_agreement.html', '《用户协议》')
  .setItem('PRIVACY', 'https://law.qingcigame.com/zh-cn/privacy_policy.html', '《隐私政策》')
  .setItem('CHILD_PRIVACY', 'https://law.qingcigame.com/zh-cn/child_privacy_policy.html', '《儿童隐私政策》')
  .setItem('TELECOM', 'https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=&hidetop=&isShowPre=&returnUrl=https%3A%2F%2Fe.dlife.cn', '《中国电信认证服务条款》')
